module.exports = __webpack_public_path__ + "static/img/surveryBack.6fbbca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveryBack.png
// module id = AqMr
// module chunks = 1